<script>
export default {
  name: 'GiftVoucher',
  data() {
    return {
      activeTab: undefined,
      centered: false,
      tabs: [
        { id: 1, name: this.$t('menu.gift-voucher.pages.booking-list.title'), route: '/gift-voucher/booking-list' },
        { id: 2, name: this.$t('menu.gift-voucher.pages.email-list.title'), route: '/gift-voucher/email-list' },
      ],
    };
  },
};
</script>
<template>
  <v-flex>
    <v-tabs
      v-model="activeTab"
      active-class="blue-grey lighten-5"
      optional
      fixed-tabs
    >
      <v-tab
        v-for="tab in tabs"
        :key="tab.id"
        :to="tab.route"
      >
        {{ tab.name }}
      </v-tab>
    </v-tabs>
    <router-view></router-view>
  </v-flex>
</template>



// WEBPACK FOOTER //
// src/pages/gift-vouchers/GiftVoucher.vue